<template>
  <div>
    <div class="row-content-auto w-100 header-purple">
      <div class="content-auto d-flex flex-row">
        <p class="mb-0 font-weight-bold pr-4">กระจายอัตโนมัติ</p>
        <router-link to="/inventory/config/0" id="inventoryAutoConfig">
          <font-awesome-icon icon="cog" /> ตั้งค่าการกระจายสินค้า</router-link
        >
      </div>

      <div class="content-auto-right d-flex flex-row">
        <p class="mb-0 pr-2 font-weight-normal">กระจายมากกว่า 100% :</p>
        <b-badge pill variant="danger" class="px-3 py-1 badge-percent"
          >เปิด</b-badge
        >
        <p class="mb-0 text-purple ml-2 font-weight-normal">
          {{ totalDistributePercent() }}%
        </p>
      </div>
    </div>

    <div class="d-flex flex-row w-100 bg-white overflow-auto">
      <div v-for="(shop, key) in distributePercentList" :key="key">
        <p class="mb-0 pl-5 py-3 market-percent">
          {{ shop.branchName }}: {{ shop.stockPercentDistribute }}%
        </p>
      </div>
    </div>

    <b-container class="py-3 px-0">
      <div class="d-flex flex-row">
        <div class="w-100 d-flex justify-content-end">
          <InventorySectionFilter
            v-on:onSubmitFilter="onSubmitFilter"
            name="Auto"
            ref="inventorySectionFilter"
          />
        </div>
      </div>
    </b-container>

    <b-table
      class="text-center table-list mb-0 bg-white"
      striped
      responsive
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      empty-text="ไม่พบข้อมูล"
    >
      <template #cell(imageUrl)="data">
        <div class="position-relative">
          <div
            class="square-box b-contain"
            v-bind:style="{
              backgroundImage: 'url(' + data.item.imageUrl + ')',
            }"
          ></div>
        </div>
      </template>

      <template #cell(productName)="data">
        <div class="product-name">
          <p class="mb-0">
            {{ data.item.productName }}
          </p>
          <p class="mb-0 text-gray1 f-size-14">
            SKU: {{ data.item.productSKU }}
          </p>
          <p class="mb-0 text-gray1 f-size-14">
            Collection: {{ data.item.collection }}
          </p>
        </div>
      </template>

      <template #cell(totalStock)="data">
        <div>{{ data.item.totalStock | numeral("0,0") }}</div>
        <b-badge
          v-if="data.item.stockStatus == 'เหลือน้อย'"
          pill
          variant="warning"
          class="px-3 text-white"
          >เหลือน้อย</b-badge
        >
      </template>

      <template #cell(onlineStock)="data">
        <div>{{ data.item.onlineStock | numeral("0,0") }}</div>
      </template>

      <template #cell(reserve)="data">
        <div>{{ data.item.reserve | numeral("0,0") }}</div>
      </template>

      <template
        v-for="field in fields.slice(5)"
        v-slot:[`cell(${field.key})`]="data"
      >
        <div :key="field.key">
          {{ getStockBranch(field.key, data.item.branch) | numeral("0,0") }}
        </div>
      </template>
    </b-table>

    <b-row class="no-gutters px-3 px-sm-0 bg-white" v-if="!isBusy">
      <b-col class="form-inline justify-content-center justify-content-sm-end">
        <div class="d-sm-flex m-3">
          <b-pagination
            v-model="filterInventoryList.page"
            :total-rows="rows"
            :per-page="filterInventoryList.pageSize"
            class="m-md-0 page-item"
            @change="pagination"
          ></b-pagination>
        </div>
        <b-form-select
          class="mr-sm-3 select-page"
          v-model="filterInventoryList.pageSize"
          @change="handleChangePerpage"
          :options="pageOptions"
        ></b-form-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InventorySectionFilter from "../inventory-filter/InventorySectionFilter.vue";
export default {
  components: {
    InventorySectionFilter,
  },
  async created() {
    this.getStockDistributePercent();
    await this.getFilter();
    this.$refs.inventorySectionFilter.setFilter({...this.filterInventoryList})
    this.getProductList();
  },
  data() {
    return {
      called: false,
      isBusy: false,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      distributePercentList: [],
      rows: 0,
      filterInventoryList: {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        stockStatus: [3],
        StartDate: "",
        EndDate: "",
        page: 1,
        pageSize: 10,
        collections: "",
      },
      totalCount: 0,
      listAllDataId: [],
      branch: [],
      items: [],
      fields: [
        {
          key: "imageUrl",
          label: "ภาพสินค้า",
          class: "w-100px text-nowrap",
        },
        {
          key: "productName",
          label: "ชื่อสินค้า/SKU",
          class: "w-100px text-nowrap",
        },
        {
          key: "totalStock",
          label: "คลังรวม",
          class: "w-80px text-nowrap",
        },
        {
          key: "onlineStock",
          label: "ออนไลน์",
          class: "w-80px text-nowrap",
        },
        {
          key: "reserve",
          label: "Reserve",
          class: "w-80px text-nowrap",
        },
      ],
    };
  },
  methods: {
    getFilter(){
      if(this.$route.query.search){
        this.filterInventoryList.search = this.$route.query.search;
      }
      if(this.$route.query.productInventoryTypes){
        this.filterInventoryList.productInventoryTypes = this.$route.query.productInventoryTypes.split(",").map(Number);
      }
      if(this.$route.query.productStatus){
        this.filterInventoryList.productStatus = this.$route.query.productStatus.split(",").map(Number);
      }
      if(this.$route.query.categories){
        this.filterInventoryList.categories = this.$route.query.categories.split(",").map(Number);
      }
      if(this.$route.query.stockStatus){
        this.filterInventoryList.stockStatus = this.$route.query.stockStatus.split(",").map(Number);
      }
      if(this.$route.query.StartDate){
        this.filterInventoryList.StartDate = this.$route.query.StartDate;
      }
      if(this.$route.query.EndDate){
        this.filterInventoryList.EndDate = this.$route.query.EndDate;
      }
      if(this.$route.query.page){
        this.filterInventoryList.page = parseInt(this.$route.query.page) || 1;
      }
      if(this.$route.query.pageSize){
        this.filterInventoryList.pageSize = parseInt(this.$route.query.pageSize) || 10;
      }
      if(this.$route.query.collections){
        this.filterInventoryList.collections = this.$route.query.collections;
      }
    },
    setFilter(filter) {
      let filterInventoryList = this.filterInventoryList;
      if(filter) filterInventoryList = filter;
      this.$router.push({ path: '/inventory', 
        query: { 
          brandID: this.$route.query.brandID,
          search: filterInventoryList.search,
          productInventoryTypes: filterInventoryList.productInventoryTypes.toString(),
          productStatus: filterInventoryList.productStatus.toString(),
          categories: filterInventoryList.categories.toString(),
          stockStatus: filterInventoryList.stockStatus.toString(),
          StartDate : filterInventoryList.StartDate || "",
          EndDate : filterInventoryList.EndDate || "",
          pageSize : filterInventoryList.pageSize ,
          page: filterInventoryList.page,
          collections: filterInventoryList.collections,
          tab: this.$route.query.tab || 1
        }
      }).catch(err => {});
    },
    async getProductList() {
      this.isBusy = true;

      await this.axios
        .post(
          `${this.$baseUrl}/stockdistribute/online`,
          this.filterInventoryList
        )
        .then((data) => {
          this.rows = data.totalCount;
          this.items = data.data.product;
          this.branch = data.data.branch;
          this.totalCount = data.totalCount;
          this.listAllDataId = data.listAllDataId;

        });

      this.addFields();
      this.isBusy = false;
    },
    addFields() {
      if (!this.called) {
        for (const i in this.branch) {
          this.fields.push({
            key: this.branch[i].branchId.toString(),
            label: this.branch[i].branchName,
            class: "w-50px text-nonwrap",
          });
        }
        this.called = true;
      }
    },
    handleChangePerpage(value) {
      this.filterInventoryList.pageSize = value;
      this.filterInventoryList.page = 1;
      this.setFilter();
      this.getProductList();
    },
    onSubmitFilter(filter) {
      this.setFilter(filter);
      this.getInventoryList(filter);
    },
    getInventoryList(filter) {
      this.filterInventoryList = filter;
      this.setFilter();
      this.getProductList();
    },
    getStockDistributePercent() {
      this.axios.get(`${this.$baseUrl}/stockdistribute`).then((data) => {
        this.distributePercentList = data.detail;
      });
    },
    getStockBranch(keyBranch, listBranch) {
      for (const index in listBranch) {
        if (listBranch[index]["branchId"] == keyBranch) {
          return listBranch[index]["stock"];
        }
      }
      return;
    },
    totalDistributePercent() {
      let totalPercent = 0;
      for (const index in this.distributePercentList) {
        totalPercent += this.distributePercentList[index][
          "lowStockPercentDistribute"
        ];
      }
      return totalPercent;
    },
    pagination(Page) {
      this.filterInventoryList.page = Page;
      this.setFilter();
      this.getProductList();
    },
  },
};
</script>

<style lang="scss" scoped>
.img-product {
  width: 100%;
  padding-bottom: 100.5%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
/deep/ .table > tbody > tr > td {
  min-width: 100px;
  // background-color: #f1f1f1;
  // border-bottom: solid 1px black;
}
.product-name {
  width: 300px;
  text-align: left;
}
a:hover {
  color: #b41bb4;
  text-decoration: underline;
  cursor: pointer;
}
.cancel-button {
  background-color: white;
  width: 150px;
}
.link-remove-info {
  color: #b41bb4;
  text-decoration: underline;
}
a {
  color: #b41bb4;
  text-decoration: underline;
}
.text-purple {
  color: #b41bb4;
}
.badge-percent {
  background-color: #b41bb4;
  color: white;
  height: fit-content;
}
.market-percent {
  color: #092d53;
}
.row-content-auto {
  display: flex;
  flex-direction: row;
}
.content-auto {
  width: 50%;
}
.content-auto-right {
  width: 50%;
  justify-content: end;
}
@media (max-width: 767.98px) {
  .row-content-auto {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .badge-percent {
    width: fit-content;
  }
  .content-auto {
    width: 100%;
  }
  .content-auto-right {
    width: 100%;
    justify-content: start;
  }
}
</style>
